(function () {
  function playCfhVideos(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.cfh-row__video[data-cfh-autoplay]').forEach(function (video) {
      if (video.tagName !== 'VIDEO') return;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {});
      }
    });
  }

  function onReady() {
    playCfhVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    playCfhVideos(event.target);
  });
})();
